module.exports = __webpack_public_path__ + "img/DSC_2662-xs.3369ddb6.png";